import script from "./SettingsPersonalDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsPersonalDetails.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsPersonalDetails.vue?vue&type=style&index=0&id=fea81d18&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fea81d18"]])

export default __exports__